export const CATEGORIASGARANTIAS = {
  1: 'CONTRATO',
  2: 'RENEGOCIAÇÃO',
  3: 'CCB'
};
